const _hero = {
	playeVisiblePoint: 85,
	targetLogoBottom: 96,
	targetLogoWidth: 200,
	videoName: 'OnFocus_Media_reel'
}

export default {
	getData(callback) {
		callback(_hero)
	}
}
